
import { useCallback, useContext, useEffect, useState } from 'react';
import LoadingSpinner from '../../UI/Loading/LoadingSpinner';
import UserContext from '../../store/UserContext';
import i18n from '../../i18n';
import useForm from './use-form';
import FormBlockHandler from './FormHandler/FormBlockHandler';
import "./scss/form.scss";
import "./scss/form-modal.scss";

const indexForms = (forms) => {
    forms && forms.forEach((form, index) => {
      form.index = index
    })
    return forms
}

const withRestFormAction = (data, restUrl) => {
    if (!data || !restUrl) return data
    const fixAction = (action) => {
      if (!action) return restUrl
      const path = String(action)
      return path.startsWith('/rest/') ? path : restUrl
    }
    return {
      ...data,
      action: fixAction(data.action),
      forms: data.forms ? data.forms.map((form) => ({ ...form, action: fixAction(form.action) })) : data.forms,
    }
}

const FormBlock = ({ url, initialData, className, post_url, multiple_form, returnTo, savedForm, saveHook, processCalback, changeForm, ordering = false, disappear = false }) => {
    const [formMeta, setFormMeta] = useState(() => withRestFormAction(initialData, url) || {})
    const [forms, setForms] = useState(() => {
      const data = withRestFormAction(initialData, url)
      return indexForms(data?.forms ? [...data.forms] : []) || []
    })
    const [formUrl, setFormUrl] = useState(url)
    const [didUseInitialData, setDidUseInitialData] = useState(Boolean(initialData))
    const [hidden, setHidden] = useState(false)

    const setIndexForms = (forms) => {
      setForms(indexForms(forms))
    }
    const [newFormUrl, setNewFormUrl] = useState(() => initialData?.add_new_form ?? null)
    const [savedAddForm, setSavedAddForm] = useState(null)
    const userContext = useContext(UserContext)
    const processForm = useCallback((data, reset) => {
        if(data['success']){  
          if(saveHook){
            saveHook(data)
            userContext.setContextReload(data.context_reload)
          }
        }
        else{
          setFormMeta(data)
          // if(reset){
          //   dispatchForms({type:'RESET_FORM'})
          // }
          if(data.forms){
            setIndexForms(data.forms)
            processCalback && processCalback(data)
            // if(formContext.form_id){
            //   var formIndex = forms.filter( (form) => form.form_id === formContext.form_id)
            //   if(formIndex.length > 0){
            //     formIndex = formIndex[0].index
            //     dispatchForms({type:'REPLACE_FORM', forms: data.forms, index: formIndex})
            //   }
            //   else{
            //     dispatchForms({type:'APPEND_FORM', forms:data.forms})
            //   }
            //   formContext.setModalForm( modalForm => ({...modalForm, form_id:null}));
            // }
            // else{
            //   dispatchForms({type:'APPEND_FORM', forms:data.forms})
            // }
          }
          setNewFormUrl(data['add_new_form'])
        }
    }, [forms, processCalback, saveHook, userContext])  

    const {isLoading : formLoading, error : formError, sendRequest : getForm} = useForm(processForm)
    const {isLoading : addFormLoading, error : addFormError, sendRequest : saveAddForm} = useForm(data => setSavedAddForm(data.forms))

    useEffect(() => {
        saveAddForm({url:newFormUrl, json:true}, false)
    }, [newFormUrl])

    const addForm = useCallback( (data) => {
      if(savedAddForm){
        savedAddForm[0].form_id =null
        setIndexForms( [...forms, ...savedAddForm])
      }
    }, [forms, savedAddForm])

    // Retrieve Form. Bootstrap stays on the original url; only refetch when formUrl changes.
    useEffect( () => {
      if (!formUrl) return
      if (didUseInitialData && initialData && formUrl === url) {
        return
      }
      if (!didUseInitialData && initialData && formUrl === url) {
        const bootstrapped = withRestFormAction(initialData, url)
        setDidUseInitialData(true)
        setFormMeta(bootstrapped)
        if (bootstrapped.forms) setIndexForms(bootstrapped.forms)
        setNewFormUrl(bootstrapped['add_new_form'])
        return
      }
      setDidUseInitialData(true)
      setForms([])
      setTimeout(() => getForm({ url: formUrl, json: true }), 100)
    }, [formUrl, didUseInitialData, initialData, url])

    var error_loading = (formError && forms.length <= 1) ? 
            <div className={`mt-2 alert ${[401, 403, 404].includes(formError) ? "alert-warning" : "alert-danger"} text-center mx-2`}>{formError}</div> 
            : (formLoading  && forms.length === 0) ?  
              <LoadingSpinner html_class='d-flex justify-content-center'/> 
              : false

    const handleButtonClick = useCallback( (data) => {
      if(changeForm){
        changeForm(data.target.dataset.url)
      }
    }, [changeForm])

    // bind handler
    useEffect(() => {
      var buttons = document.querySelectorAll('.form-change-button')
      buttons.forEach((element) => {
        element.addEventListener("click", handleButtonClick);
      })
    }, [formMeta, formMeta.message, handleButtonClick]);

    const localSaveHook = (forms, index) => {
      const allSuccess = forms.every(form => form.success || form.valid)
      if(allSuccess && forms[index].redirect_url){
        setFormUrl(forms[index].redirect_url)
      }
      if(allSuccess && saveHook){
        saveHook(forms, index)
      }
      if(allSuccess && disappear){
        setHidden(true)
      }
    } 

    const formFunc = useCallback( 
        (form, index) => {return <FormBlockHandler
              key={form.form_id || form.index}
              form_id={form.form_id}
              index={index}
              formIndex={form.index}
              forms={forms}
              form={form}
              classes={className + " rest-form"}
              url={formUrl} 
              returnTo={returnTo} 
              savedForm={savedForm} 
              saveHook={localSaveHook} 
              changeForm={changeForm}
              multiple_form={multiple_form}
              setForms={setForms}
            />
    } , [forms, setForms, formUrl, saveHook, className, changeForm, multiple_form, disappear])

    if(hidden){
      return null
    }

    if(error_loading){
      return error_loading
    }

    return (
      <>
        {formMeta.message ? <div className="form-message" > <div className="d-flex flex-column overflow-auto" dangerouslySetInnerHTML={{ __html: formMeta.message }} /> </div> : ''}
        <div className={` d-flex flex-column mt-2 px-3 `}>
          {
            newFormUrl && (
                <a type='button' onClick={addForm} className="btn btn-sm p-1 small btn-outline-primary mx-auto mb-3" style={{'top': '-15px'}}>
                  + {i18n.t('Add another')}
                </a>
              ) 
          }
          { (ordering === true) ?  forms.toReversed().map(formFunc) : forms.map(formFunc) }
        </div>
      </>
    );
}

export default FormBlock

